module.exports = __webpack_public_path__ + "media/images/about_us/developpement-11f6c391f33b6c69648f6eb56ab77f0c.svg";